import * as sdk from 'commerce-sdk-isomorphic'
import {keysToCamel} from '../commerce-api/utils'

const getConfigurationValue = (configurations, ids) => {
    const config = configurations?.find(({id}) => ids.includes(id))
    return config?.value
}

class ShopperConfigurationsSite {
    constructor(config) {
        this.shopperConfigurations = new sdk.ShopperConfigurations(config)
    }

    /**
     * Calls the SCAPI shopper configurations endpoint for site metadata.
     */
    async getDefaultSite(...args) {
        const [options = {}] = args
        const response = await this.shopperConfigurations.getConfigurations({
            ...options,
            parameters: {
                personalized: 'none',
                ...options.parameters
            }
        })
        const site = keysToCamel(response || {})
        const configurations = site.configurations || []

        return {
            ...site,
            allowedLocales:
                site.allowedLocales ||
                getConfigurationValue(configurations, ['allowedLocales', 'supportedLocales']),
            httpsHostname:
                site.httpsHostname ||
                site.httpsHostName ||
                getConfigurationValue(configurations, ['httpsHostname', 'httpsHostName']),
            httpsDisBaseUrl:
                site.httpsDisBaseUrl ||
                getConfigurationValue(configurations, ['httpsDisBaseUrl', 'disBaseUrl'])
        }
    }
}

export default ShopperConfigurationsSite
